class DynamicDates extends HTMLElement {
  connectedCallback() {
    this.monthLabels = (this.dataset.monthLabels || 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec')
      .split(',').map((s) => s.trim());
    this.daysToSkip = (this.dataset.daysToSkip || '')
      .split(',').map((s) => s.trim()).filter(Boolean);
    this.datesToSkip = (this.dataset.datesToSkip || '')
      .split(',').map((s) => s.trim()).filter(Boolean);

    this.querySelectorAll('[data-dynamic-date="true"]').forEach((el) => {
      const text = el.dataset.text || '';
      const minDays = parseInt(el.dataset.minDays || '0', 10);
      const maxDays = parseInt(el.dataset.maxDays || '0', 10);
      const startDate = this.addBusinessDays(new Date(), minDays);
      const endDate = this.addBusinessDays(new Date(), maxDays);

      let out = text;
      if (out.indexOf('[start_date]') !== -1) {
        out = out.replace('[start_date]', this.formatDate(startDate));
      }
      if (out.indexOf('[end_date]') !== -1) {
        out = out.replace('[end_date]', this.formatDate(endDate));
      }
      el.innerHTML = out;
    });
  }

  isSkippedDay(date) {
    const fullDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayName = fullDayNames[date.getDay()];
    if (this.daysToSkip.some((d) => d.toLowerCase() === dayName.toLowerCase())) return true;
    const iso = date.toISOString().slice(0, 10);
    if (this.datesToSkip.includes(iso)) return true;
    return false;
  }

  addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (!this.isSkippedDay(result)) added++;
    }
    while (this.isSkippedDay(result)) {
      result.setDate(result.getDate() + 1);
    }
    return result;
  }

  ordinalSuffix(n) {
    const j = n % 10;
    const k = n % 100;
    if (j === 1 && k !== 11) return n + 'st';
    if (j === 2 && k !== 12) return n + 'nd';
    if (j === 3 && k !== 13) return n + 'rd';
    return n + 'th';
  }

  formatDate(date) {
    const month = this.monthLabels[date.getMonth()];
    const day = date.getDate();
    return `${month} ${this.ordinalSuffix(day)}`;
  }
}

if (!customElements.get('dynamic-dates')) {
  customElements.define('dynamic-dates', DynamicDates);
}